enum ItemType {
  all = 'all',
  comment = 'comment',
  post = 'post',
}

enum Confidence {
  all = 'all',
  lowConfidence = 'lowConfidence',
  highConfidence = 'highConfidence',
}

enum SortOptions {
  newest = 'newest',
  oldest = 'oldest',
}

export { Confidence, ItemType, SortOptions };
